import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "./style.less";
import UserPanel from "./UserPanel";
import ReportExportList from "./ReportExportList";
// import { DownOutlined } from '@ant-design/icons';
import type { MenuProps } from 'antd';
import { Dropdown, Space } from 'antd';
import t_gysj from '@/assets/icons/gysj.svg'
import t_zxyh from '@/assets/icons/zxyh.svg'
import gysj from '@/assets/icons/gysj.svg'
import zxyh from '@/assets/icons/zxyh.svg'
import logo from "@/assets/loginLogo.svg";

import logo_white from '@/assets/loginLogo.svg'

const Component = (props: any) => {
  const useLocations: any = useLocation();
  const history = useNavigate();
  const { title, mainContent, extra } = props;

  const items: MenuProps['items'] = [
    {
      label: (
        <div className={title === '工艺设计' ? 'top_submenu active' : 'top_submenu'}
          onClick={() => {
            history('/project')
          }}
        ><img src={gysj} /><i>工艺设计</i></div>
      ),
      key: '0',
    },
    {
      type: 'divider',
    },
    {
      label: (
        <div className={title === '在线优化' ? 'top_submenu active' : 'top_submenu'}
          onClick={() => { history('/operation') }}
        ><img src={zxyh} /><i>在线优化</i></div>
      ),
      key: '1',
    },

  ];

  const gongyiDesignTitle = () => {

  }

  // const showPageTitle = () => {
  //   if (title === "工艺设计") {
  //     return
  //   }
  // }

  const showPageIcon = () => {
    if (title === "工艺设计") {
      return <img src={t_gysj} alt="" />
    } else if (title === "在线优化") {
      return <img src={t_zxyh} alt="" />
    }
  }


  return (
    <div className="topBar">
      {/* 左侧区域：标题和下拉菜单 */}
      <div className="top-left-container">
        <div className="logoPic" style={{marginLeft:'3rem',cursor:'pointer',marginRight:'10rem'}}
        onClick={()=>history('/project/home/list')}
        >
          <img src={logo} style={{width:'350px'}} />
        </div>
        {/* <Dropdown menu={{ items }} trigger={['click']}>
          <div className="top_pageTitle">
            <div className="pageLogo">{showPageIcon()}</div>
            <div className="pageName">
              <div className="title">{title}</div>
              <div className="wlogo"><img src={logo_white} alt="Logo" /></div>
            </div>
          </div>
        </Dropdown> */}
      </div>
      
      {/* 中间区域：主要内容 */}
      <div className="top-center-container">
        <div className="top_mainContent">{mainContent}</div>
      </div>
      
      {/* 右侧区域：额外内容、导出列表和用户面板 */}
      <div className="top-right-container">
        <div className="extra-content-container">
          {extra}
        </div>

        {/* 导出列表：始终显示，位于用户图标左侧 */}
        <div style={{ display: "flex", alignItems: "center", marginRight: 10 }}>
          <ReportExportList />
        </div>

        <div className="user-panel-container">
          <div className="top_pageRight">
            <UserPanel />
          </div>
        </div>
      </div>
    </div>
    
  );
};

export default Component;
